import React, { useState } from 'react';

import { checkTenant } from '@libs/NwUtils';

import { useUserPermission } from '@contexts/UserContext';

import { forceReloadAccommodation } from '@hooks/API/Event/UseAccommodation';

import { EventActionsToolbar } from '@components/EventDrawer/EventDrawerUi/EventUI';
import { NwAddButton } from '@components/Gui/NwButton';
import NwUpload from '@components/Gui/NwUpload';
import AddNonBookingEventTransactionDrawer from '@components/Transactions/TransactionsDrawer/AddNonBookingEventTransactionDrawer';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const AccommodationActions = ({ plainMode, accommodationData, onAddModels }) => {
    const [transactionDrawer, setTransactionDrawer] = useState(false);
    const accessAccounting = useUserPermission('AccessAccounting');

    const getUploadEndpoint = () => {
        let endpoint = `documents/upload/1?eventGroupGuid=${accommodationData.GroupGuid}`;
        if (accommodationData.Project) {
            endpoint = endpoint + `&projectID=${accommodationData.Project.ID}`;
        }
        return endpoint;
    };

    const onAfterAddingExpense = () => {
        forceReloadAccommodation(accommodationData.ID);
        setTransactionDrawer(false);
    };

    const isEliteBooker = checkTenant('elitemodels', true) && !accessAccounting;

    return (
        <>
            <EventActionsToolbar plainMode={plainMode}>
                {accommodationData.GroupGuid && (
                    <NwUpload
                        size="small"
                        label="add document"
                        maxSize={20}
                        showList={false}
                        types={['all']}
                        onUploadEnd={() => {
                            forceReloadAccommodation(accommodationData.ID);
                        }}
                        endpoint={getUploadEndpoint()}
                    />
                )}
                <NwAddButton size="small" ghost onClick={onAddModels} label="add models" />
                {!accommodationData.ProjectID && !isEliteBooker && (
                    <NwAddButton
                        ghost
                        onClick={() => {
                            setTransactionDrawer(true);
                        }}
                        label="add expense"
                        icon={byPrefixAndName.fass['comment-plus']}
                    />
                )}
            </EventActionsToolbar>
            {transactionDrawer && (
                <AddNonBookingEventTransactionDrawer
                    event={accommodationData}
                    eventType="accommodation"
                    onClose={() => setTransactionDrawer(false)}
                    onSave={onAfterAddingExpense}
                />
            )}
        </>
    );
};

export default AccommodationActions;
